const themeToVars = ({ scheme, prefix, }) => Object.entries(scheme).map(([key, value]) => `--${prefix}-${key.replace(/_/g, '-')}: ${value};`);
const applyTheme = (theme, childThemes = []) => {
    var _a;
    const $head = document.querySelector('head');
    if (!$head)
        throw 'No head element. Unable to apply theme.';
    const $theme = (_a = $head.querySelector('style[data-theme]')) !== null && _a !== void 0 ? _a : createStyleSheet($head);
    const colorVars = [];
    colorVars.push(...themeToVars(theme));
    for (const childTheme of childThemes) {
        colorVars.push(...themeToVars(childTheme));
    }
    $theme.innerHTML = `
:root {
    color-scheme: ${theme.meta.shade};

    --theme-name: ${theme.name};
    --theme-shade: ${theme.meta.shade};
    --theme-contrast: ${theme.meta.contrast};

    ${colorVars.join('\n    ')}
}

body {
    background-color: var(--color-background);
    color: var(--color-foreground);
}
    `;
};
const createStyleSheet = ($head) => {
    const stylesheet = document.createElement('style');
    stylesheet.setAttribute('data-theme', '');
    $head.prepend(stylesheet);
    return stylesheet;
};

export { applyTheme };
